/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trialsubscriptionconfirmtitle3Inputs */

const en_trialsubscriptionconfirmtitle3 = /** @type {(inputs: Trialsubscriptionconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate Trial Subscription`)
};

const de_trialsubscriptionconfirmtitle3 = /** @type {(inputs: Trialsubscriptionconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testabo aktivieren`)
};

/**
* | output |
* | --- |
* | "Activate Trial Subscription" |
*
* @param {Trialsubscriptionconfirmtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const trialsubscriptionconfirmtitle3 = /** @type {((inputs?: Trialsubscriptionconfirmtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trialsubscriptionconfirmtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trialsubscriptionconfirmtitle3(inputs)
	return de_trialsubscriptionconfirmtitle3(inputs)
});
export { trialsubscriptionconfirmtitle3 as "trialSubscriptionConfirmTitle" }